import React, {useMemo} from "react";
import {Stack, TextField} from "@mui/material";
import {WorkSiteForm} from "../../api/Model";
import {formPatcher, inputChange, SetState} from "../../util/FormHandlers";
import ColorPicker from "../../components/color-picker/ColorPicker";
import EmojiPicker from "../../components/emoji-picker/EmojiPicker";

export function HibobResidenceSiteFormDialog({form, setForm}: {
    form: WorkSiteForm,
    setForm: SetState<WorkSiteForm>,
}) {
    const handlers = useMemo(() => ({
        handleEmojiChange: formPatcher(setForm, (newValue: string) => ({
            emoji: newValue || undefined,
        })),
        handleBadgeChange: inputChange(setForm, newValue => ({
            badge: newValue || undefined,
        })),
        handleColorChange: formPatcher(setForm, (newValue: string) => ({
            color: newValue || undefined,
        })),
    }), [setForm]);

    return (
        <Stack spacing={2} direction="column" sx={{pt: 2}}>
            <TextField
                autoFocus
                margin="dense"
                id="badge"
                label="Badge"
                type="text"
                fullWidth
                variant="outlined"
                value={form.badge || ''}
                onChange={handlers.handleBadgeChange}
            />
            <EmojiPicker
                clearable
                margin="dense"
                id="emoji"
                label="Emoji"
                fullWidth
                variant="outlined"
                value={form.emoji || ''}
                onChange={handlers.handleEmojiChange}
            />
            <ColorPicker
                clearable
                margin="dense"
                id="color"
                label="Color"
                fullWidth
                variant="outlined"
                value={form.color}
                onChange={handlers.handleColorChange}
                slotProps={{inputLabel: {shrink: true}}}
            />
        </Stack>
    );
}
